/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".progress-activity[_ngcontent-%COMP%]{text-align:center}@media (min-width:768px){.progress-activity[_ngcontent-%COMP%]{display:flex;justify-content:space-between}}"];
export { styles as styles };
